<template>
    <div>
        <kt-datatable ref="datatable" v-bind="datatableProps" v-on:change="$emit('filter', $event)"></kt-datatable>
    </div>
</template>

<script>
import {StarShopApiUrl} from "@/common/api.service";
import {AuthorizationHeader} from "@/common/jwt.service";
import columns from './datatable/columns_customers';
import actionsColumn from './components/actions-column-customer'

export default {
    name: 'customers-without-manage',
    props: {
        query: {
            type: Object,
            required: true
        }
    },
    computed: {
        datatableProps() {
            return {
                id: 'datatable',
                data: {
                   type: 'remote',
                   source: {
                       read: {
                           url: StarShopApiUrl.path('customer'),
                           method: 'GET',
                           headers: AuthorizationHeader,
                           map: function(res) {
                               return res.data.data
                           },
                           params: {
                               query: this.query
                           },
                       }
                   },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {
                },
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actionsColumn
            }
        },
    },
    watch: {
        query: {
            handler(newQuery) {
                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload();
                }
            },
            deep: true
        }
    }
}
</script>